export const colors = {
  navbarColor: "#F5F7F8",
  primaryColor: "#22162Bfc1444",
  secondaryColor: "#40A2E3",
  tertiaryColor: "red",
  accentColor: "#F85A3E",
  altColor: "#",
};
